import { render, staticRenderFns } from "./ResetPharmacy.vue?vue&type=template&id=02dac15f&"
import script from "./ResetPharmacy.vue?vue&type=script&lang=ts&"
export * from "./ResetPharmacy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports